<template>
  <div class="content-loader" data-testid="content-display-loader">
    <div class="content-loader__block">
      <slot />
    </div>
    <div
      v-if="hasButton"
      class="content-loader__button"
      data-testid="content-button-loader"
    >
      <SkeletonLoader>
        <div class="content-loader__button__text" />
      </SkeletonLoader>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

import { SkeletonLoader } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    SkeletonLoader
  }
})
export default class ContentDisplayLoader extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hasButton!: boolean;
}
</script>

<style lang="less" scoped>
.content-loader {
  border: @size-border-x400 solid @divider-primary;
  border-radius: @size-radius-x200;

  &__block {
    padding: @size-spacing-x500 @size-spacing-x600;
  }

  &__button {
    border-top: @size-border-x400 solid @divider-primary;
    padding: @size-spacing-x400 @size-spacing-x600;

    &__text {
      width: 25%;
      height: 24px;
      border-radius: @size-radius-x100;
    }
  }
}
</style>
